import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const ProjectStatusStr = {
    READY: '준비중',
    IN_PROGRESS: '진행중',
    FINISH: '완료',
    REMOVED: '삭제',
}

class ProjectItem extends Component {
    constructor(props) {
        super(props)

        this.state = {
            user: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.setState({
            user: this.props.user,
        })
    }

    handleCookie = async () => {
        const { cookies } = this.props
        const expire = new Date()
        expire.setDate(expire.getDate() + 365)

        // 환경 설정 가져오기
        const settings = await axios.get(`${PROXY_HOST}/api/solutionSetting?project_id=${this.props.list._id}`)

        // 채팅방 ID 가져오기
        const projectInfo = await axios.get(`${BACKEND_HOST}/projects/${this.props.list._id}`, {
            headers: {
                Authorization: `bearer ${Auth.getToken()}`,
            },
        })
        const channelUrl = projectInfo.data.chatroom?._id

        cookies.set('project_status', this.props.list.status, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_name', this.props.list.title, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project', this.props.list._id, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_detailReport', settings.data.detailReport, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_cctvView', settings.data.cctvView, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_scan3dView', settings.data.scan3dView, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_chatOpen', settings.data.chatOpen, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        cookies.set('project_chatRoom', channelUrl, {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        //TODO:V2 프로젝트 Role 설정 필요
        cookies.set('project_role', 'CLIENT', {
            path: '/',
            maxAge: 31536000,
            expires: expire,
        })
        this.props.history.push(`/`)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/api/userInfo`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const appName = this.props.cookies.get('app_name')
        let EmptyImg = require('../../../Res/img/hausplanner_logo_gold.png')
        let thumbnailClassName = 'thumbnail_wrap'
        if (appName && appName !== '' && appName !== 'hausplanner') {
            EmptyImg = require(`../../../Res/3rd/${appName}/img/empty_img.png`)
            thumbnailClassName = 'thumbnail_wrap_blank'
        }
        if (this.state.user) {
            return (
                <li className="project_item" onClick={() => this.props.onClick()}>
                    <div className={thumbnailClassName} onClick={this.handleCookie}>
                        <div className="thumbnail">
                            {this.props.list.thumbnailUrl ? (
                                <LazyLoadImage src={this.props.list.thumbnailUrl} />
                            ) : (
                                <img src={EmptyImg} />
                            )}
                        </div>
                    </div>
                    <div className="text_wrap" onClick={this.handleCookie}>
                        <p className="project_name">{this.props.list.title}</p>
                        <p className="name">상태. {ProjectStatusStr[this.props.list.status]}</p>
                        <p className="address">주소. {this.props.list.address.jibunAddress}</p>
                    </div>
                </li>
            )
        }
        return <div />
    }
}

export default withCookies(ProjectItem)



// WEBPACK FOOTER //
// ./Src/Components/Project/ProjectItem.js